/**
 * Aiká — Página de produto
 * Sincroniza seleção de variante (botões) com preço, disponibilidade
 * e o input escondido que vai pro formulário do carrinho.
 * Também controla o stepper de quantidade.
 * Adiciona ao carrinho via AJAX (sem navegar pra /cart nem abrir nada),
 * mostra um aviso discreto e tenta atualizar o numerozinho do carrinho
 * no cabeçalho.
 */

function aikaShowCartToast(message) {
  let toast = document.querySelector('[data-cart-toast]');

  if (!toast) {
    toast = document.createElement('div');
    toast.setAttribute('data-cart-toast', '');
    toast.className = 'aika-cart-toast';
    document.body.appendChild(toast);
  }

  toast.textContent = message;
  toast.classList.remove('is-visible');
  // Força reflow pra reiniciar a transição em cliques consecutivos.
  void toast.offsetWidth;
  toast.classList.add('is-visible');

  clearTimeout(toast._aikaHideTimeout);
  toast._aikaHideTimeout = setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 3200);
}

function aikaUpdateCartBubble() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then((res) => res.json())
    .then((cart) => {
      document
        .querySelectorAll(
          '[data-cart-count], .cart-count-bubble, #cart-icon-bubble [data-cart-count], [data-header-cart-count]'
        )
        .forEach((el) => {
          el.textContent = cart.item_count;
          if ('hidden' in el) el.hidden = cart.item_count === 0;
        });

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    })
    .catch((error) => {
      console.error('Erro ao atualizar contador do carrinho:', error);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const jsonEl = section.querySelector('[data-product-json]');
    let variants = [];

    if (jsonEl) {
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (error) {
        variants = [];
      }
    }

    const optionGroups = Array.from(section.querySelectorAll('[data-option-index]'));
    const variantIdInput = section.querySelector('[data-variant-id]');
    const priceValue = section.querySelector('[data-price-value]');
    const installmentsEl = section.querySelector('[data-installments]');
    const addToCartBtn = section.querySelector('[data-add-to-cart]');
    const addToCartText = section.querySelector('[data-add-to-cart-text]');
    const paymentButtonWrap = section.querySelector('[data-payment-button-wrap]');
    const form = section.querySelector('#aika-product-form');
    const productTitle = addToCartBtn ? addToCartBtn.dataset.productTitle || '' : '';

    let currentVariant =
      variants.find((v) => String(v.id) === (variantIdInput ? variantIdInput.value : '')) || null;

    // Estado combinado: só pode comprar se a variante estiver disponível
    // E (se houver seleção múltipla) ela estiver completa.
    // Parte do estado já renderizado pelo Liquid (disabled inicial), não assume "true" às cegas.
    let variantAvailable = addToCartBtn ? !addToCartBtn.disabled : true;
    let multiSelectComplete = true;

    const updateAddToCartState = () => {
      const canPurchase = variantAvailable && multiSelectComplete;
      if (addToCartBtn) addToCartBtn.disabled = !canPurchase;
      if (addToCartText) {
        addToCartText.textContent = variantAvailable ? 'Adicionar ao carrinho' : 'Esgotado';
      }
      if (paymentButtonWrap) {
        paymentButtonWrap.classList.toggle('is-hidden-by-selection', !canPurchase);
      }
    };

    const formatMoney = (cents) => (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    const getSelectedOptions = () =>
      optionGroups.map((group) => {
        const active = group.querySelector('.aika-variant-btn[data-active="true"]');
        return active ? active.dataset.optionValue : null;
      });

    const findMatchingVariant = (selected) =>
      variants.find((variant) =>
        selected.every((value, index) => value === null || variant[`option${index + 1}`] === value)
      );

    const updateForVariant = (variant) => {
      if (!variant) return;

      currentVariant = variant;

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceValue) priceValue.textContent = formatMoney(variant.price);
      if (installmentsEl) {
        installmentsEl.textContent = `ou 3x de ${formatMoney(Math.round(variant.price / 3))} sem juros`;
      }
      if (addToCartText) {
        addToCartText.textContent = variant.available ? 'Adicionar ao carrinho' : 'Esgotado';
      }
      variantAvailable = variant.available;
      updateAddToCartState();
    };

    section.querySelectorAll('.aika-variant-btn:not([data-multi-select-option])').forEach((btn) => {
      if (btn.classList.contains('is-selected')) {
        btn.dataset.active = 'true';
      }

      btn.addEventListener('click', () => {
        const group = btn.closest('[data-option-index]');
        group.querySelectorAll('.aika-variant-btn').forEach((other) => {
          other.dataset.active = 'false';
          other.classList.remove('is-selected');
        });

        btn.dataset.active = 'true';
        btn.classList.add('is-selected');

        const variant = findMatchingVariant(getSelectedOptions());
        updateForVariant(variant);
      });
    });

    const qtyInput = section.querySelector('[data-quantity-input]');
    const qtyMinus = section.querySelector('[data-quantity-minus]');
    const qtyPlus = section.querySelector('[data-quantity-plus]');

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, current - 1);
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', () => {
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = current + 1;
      });
    }

    // Multi-seleção (ex: "escolha 3 velas entre 7")
    const multiSelect = section.querySelector('[data-multi-select]');
    let multiSelectRequired = 0;
    let multiSelectSelected = [];
    let multiSelectHint = null;

    if (multiSelect) {
      const required = parseInt(multiSelect.dataset.required, 10) || 1;
      const options = Array.from(multiSelect.querySelectorAll('[data-multi-select-option]'));
      const counter = multiSelect.querySelector('[data-multi-select-counter]');
      const hint = multiSelect.querySelector('[data-multi-select-hint]');
      const hiddenInput = multiSelect.querySelector('[data-multi-select-value]');
      let selected = [];

      multiSelectRequired = required;
      multiSelectHint = hint;

      const refresh = () => {
        if (counter) counter.textContent = `${selected.length} de ${required} selecionadas`;
        if (hiddenInput) hiddenInput.value = selected.join(', ');

        options.forEach((option) => {
          if (option.hasAttribute('data-unavailable')) return;
          const name = option.dataset.optionName;
          const isSelected = selected.includes(name);
          option.classList.toggle('is-selected', isSelected);
          option.classList.toggle('is-disabled', !isSelected && selected.length >= required);
        });

        multiSelectComplete = selected.length === required;
        multiSelectSelected = selected;
        if (hint) hint.classList.toggle('is-visible', !multiSelectComplete);
        updateAddToCartState();
      };

      options.forEach((option) => {
        if (option.hasAttribute('data-unavailable')) return;
        option.addEventListener('click', () => {
          const name = option.dataset.optionName;
          if (selected.includes(name)) {
            selected = selected.filter((item) => item !== name);
          } else if (selected.length < required) {
            selected.push(name);
          }
          refresh();
        });
      });

      refresh();
    } else {
      updateAddToCartState();
    }

    // Envio do formulário: adiciona via AJAX, sem navegar pra /cart
    // e sem abrir nenhuma gaveta — a pessoa continua na página.
    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (multiSelect && multiSelectSelected.length !== multiSelectRequired) {
          if (multiSelectHint) multiSelectHint.classList.add('is-visible');
          multiSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        if (addToCartBtn && addToCartBtn.disabled) return;

        const originalLabel = addToCartText ? addToCartText.textContent : '';

        if (addToCartBtn) addToCartBtn.disabled = true;
        if (addToCartText) addToCartText.textContent = 'Adicionando...';

        try {
          const formData = new FormData(form);

          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            body: formData
          });

          if (!response.ok) {
            let errorMessage = 'Não foi possível adicionar ao carrinho.';

            try {
              const errorData = await response.json();
              if (errorData.description) errorMessage = errorData.description;
            } catch (jsonError) {}

            throw new Error(errorMessage);
          }

          const addedItem = await response.json();

          aikaUpdateCartBubble();

          const label =
            currentVariant && currentVariant.title && currentVariant.title !== 'Default Title'
              ? `${productTitle} - ${currentVariant.title}`
              : productTitle;

          aikaShowCartToast(`${label} foi adicionado ao carrinho`);

          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: addedItem } }));
        } catch (error) {
          console.error('Erro ao adicionar ao carrinho:', error);
          aikaShowCartToast(error.message || 'Não foi possível adicionar ao carrinho.');
        } finally {
          if (addToCartBtn) addToCartBtn.disabled = !(variantAvailable && multiSelectComplete);
          if (addToCartText) {
            addToCartText.textContent = variantAvailable ? 'Adicionar ao carrinho' : originalLabel || 'Esgotado';
          }
        }
      });
    }
  });
});
